export const VIEWS = {
  GROUP_STAGE: 'group-stage',
  RANKING: 'ranking',
  BRACKET: 'bracket',
};

export const VIEW_LABELS = {
  [VIEWS.GROUP_STAGE]: 'eventodeportivo_tablaposiciones_texto_titulo_fasegrupos',
  [VIEWS.RANKING]: 'eventodeportivo_tablaposiciones_texto_titulo_ranking',
  [VIEWS.BRACKET]: 'eventodeportivo_tablaposiciones_texto_titulo_vistatorneo',
};